<app-line-style-swatch [class.selected]="selected === GetDash(0)"
   tabIndex="0" (click)="SelectSwatch(GetDash(0))"
   (dblclick)="HandleDoubleClick($event,GetDash(0))"
   (keyup)="HandleKey($event,0)"
   [thickness]="thickness" [color]="color" [width]="324"
  [height]="swatchHeight" [dash]="solidDash">
</app-line-style-swatch>
<ng-container  *ngFor="let i of this.dashes.length|iterate">
  <app-line-style-swatch [class.selected]="GetDash(i) === selected"
    (keyup)="HandleKey($event,i)" tabindex="0"
    *ngIf="i > 0"
    (click)="SelectSwatch(GetDash(i))"
    (dblclick)="HandleDoubleClick($event,GetDash(1))"
    [dash]="GetDash(i)" [thickness]="thickness"
    [color]="color" [width]="swatchWidth" [height]="swatchHeight">
  </app-line-style-swatch>
</ng-container>
